// A4 in points, which the PDF is typeset on and the Word document is set up for, so the two break lines alike.
export const PAGE_WIDTH = 595.28;
export const PAGE_HEIGHT = 841.89;

// A little under 20mm at either side of the sheet.
export const MARGIN = 52;
export const MEASURE = PAGE_WIDTH - MARGIN * 2;
